import * as t from 'io-ts';

import { Decoding } from '@catawiki/runtime-toolkit';

const Image = t.interface({
  small: t.string,
  medium: t.string,
  original: t.string,
});

const Auctioneer = t.interface({
  id: t.number,
  name: t.string,
  image_large: Decoding.nullable(t.string),
  image_small: Decoding.nullable(t.string),
  profile_complete: t.boolean,
});

export const Auction = t.interface({
  id: t.number,
  close_at: t.string,
  closed_at: Decoding.nullable(t.string),
  start_at: t.string,
  lot_count: t.number,
  number_of_lots: t.number,
  title: t.string,
  type_id: t.number,
  theme_id: Decoding.nullable(t.number),
  themed: t.boolean,
  url: t.string,
  explicit_content: t.boolean,
  images: t.interface({
    5: t.string,
    6: t.string,
    original: t.string,
  }),
  status: t.string,
  promo_images: t.array(Image),
  has_context: t.boolean,
  auctioneers: t.array(Auctioneer),
});

export type Auction = t.TypeOf<typeof Auction>;
export type Auctioneer = t.TypeOf<typeof Auctioneer>;
